import {TAllNews, TAllNewsItem} from "@/app/[locale]/news/types";
import {saveToLocalStorage} from "@/app/[locale]/common/utils/functions/saveToLocalStorage/saveToLocalStorage";
import {GENERAL_URL, STATUS_CODE} from "../../../constants/app";
import {Dispatch, SetStateAction} from "react";
import {extractTextNewsFromJSON} from "@/app/[locale]/common/utils/functions/extractTextNewsFromJSON/extractTextNewsFromJSON";

export const getAllNews = async (currentPage: number, setData?:  Dispatch<SetStateAction<TAllNewsItem[] | null>>, setRowTotalCount?: Dispatch<SetStateAction<number>>) => {
    try {
        const res = await fetch(`${GENERAL_URL}/articles?page=${currentPage}&size=4`, { cache: 'no-store' });

        if (res.status === STATUS_CODE.SUCCESS) {
            const data: TAllNews = await res.json();
            if (setData) {
                const news = extractTextNewsFromJSON(data.items);
                setData(news);
            }

            if (setRowTotalCount) {
                setRowTotalCount(data.rowTotalCount);
            }

            if (currentPage === 1) {
                saveToLocalStorage('news', data.items);
                saveToLocalStorage('rowTotalCount', data.rowTotalCount);
            }
        }
    } catch (err) {
        console.log(err);
    }
};